import React from "react";
import MasterFoodLibrary from "./MasterFoodLibrary";
import { BuildMealModal } from "../../athlete-portal/nutrition/meal-planner/modals/BuildMealModal";
import { HandleFoodModal } from "../../athlete-portal/nutrition/meal-planner/modals/HandleFoodModal";

const MasterFoodLibraryController = async ({ api, res, req, locals, load }) => {
  const { query } = req;

  const modal = query.modal || {};
  const mealPlanPromises = [load("foodsByCoach"), load("mealsByCoach")];
  switch (modal.type) {
    case "handle-meal-planner-food":
      mealPlanPromises.push(load("mostUsedMealPlans"));
      break;
    case "build-meal":
      mealPlanPromises.push(load("mostUsedMealPlans"), load("customFoods"));
      break;
    default:
      break;
  }
  await Promise.all(mealPlanPromises);

  locals.modal = {
    "handle-meal-planner-food": <HandleFoodModal locals={locals} />, //create-edit a food
    "build-meal": <BuildMealModal locals={locals} api={api} />, //create and edit a meal
  }[modal.type];

  res.body = <MasterFoodLibrary locals={locals} query={query} />;
};

export default MasterFoodLibraryController;
